import Datepicker from 'vuejs-datepicker';

export default {
    components: { Datepicker },
    data: () => ({
        call_notification1: null,
        call_notification2: null,
        call_notification3: null,
        dateFrom: '',
        dateTo: '',
    }),
    methods: {
        clearFilter() {
            this.dateFrom = '';
            this.dateTo = '';
            console.log('clear filter');
        }
    }
}